// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"0f9c9c1f","208":"03929006","480":"e5623004","579":"76087c90"}[chunkId] + ".chunk.js";
};